import MetricGauge from './MetricGauge';
import { isPercentValue } from '../../fonctions/fonctions';

function MetricsGrid({ server, onMetricClick }) {
  const metrics   = server.metrics || [];
  const isOffline = (server.server_status || '').toLowerCase().includes('hors ligne');

  if (metrics.length === 0) {
    return (
      <div style={{
        padding: '1rem 1.25rem', color: 'var(--text-muted)',
        fontSize: '0.82rem', fontStyle: 'italic',
        background: '#f8fafc', borderTop: '1px solid var(--border)',
      }}>
        Aucune métrique disponible
      </div>
    );
  }

  // Pourcentages en premier, puis le reste — dans une seule grille uniforme
  const sorted = [
    ...metrics.filter(m =>  isPercentValue(m.value)),
    ...metrics.filter(m => !isPercentValue(m.value)),
  ];

  return (
    <div style={{ background: '#f8fafc', borderTop: '1px solid var(--border)', animation: 'fadeIn 0.2s ease both' }}>

      {isOffline && metrics.length > 0 && (
        <div style={{
          margin: '0.75rem 1.25rem 0',
          padding: '0.55rem 1rem',
          borderRadius: 'var(--radius-sm)',
          background: '#fff5f5', border: '1px solid #fecaca',
          color: '#b91c1c', fontSize: '0.77rem', fontWeight: 500,
        }}>
          Dernières métriques connues — serveur actuellement injoignable
        </div>
      )}

      <div style={{
        display:             'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))',
        gap:                 '0.65rem',
        padding:             '0.85rem 1.25rem',
      }}>
        {sorted.map((metric, i) => (
          <MetricGauge
            key={i}
            metric={metric}
            onClick={() => onMetricClick(server, metric)}
          />
        ))}
      </div>

    </div>
  );
}

export default MetricsGrid;
